export const introPostUrl =
  'https://medium.com/@cocobuild/meet-coco-a-real-time-co-creative-learning-platform-for-young-people-bdfe23edd5a7?source=friends_link&sk=f8ccd78b00a3ab17c59f7253d9fffebd';
export const videoUrl = 'https://www.youtube.com/embed/vvWt0rjco0w?rel=0';
export const twitterUrl = 'https://twitter.com/cocobuild';
export const linkedinUrl = 'https://linkedin.com/company/cocobuild';
export const youtubeUrl = 'https://youtube.com/@cocobuild';
export const typeformId = 'j1Z5cXuz';
export const typeformBaseUrl = 'https://7m9tuhcw32u.typeform.com/to/j1Z5cXuz';
export const llmPostUrl = 'https://coco.build/llm';
